import React from 'react';
import Logo from '../Logo';

export function LoadingState() {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <Logo className="mx-auto mb-8" />
      
      <div className="text-center mb-12">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
          Generating Your Recommendations
        </h2>
        <p className="text-gray-600 max-w-lg mx-auto">
          We're analyzing your business profile to find the perfect tools...
        </p>
      </div>
      
      {/* Skeleton loading for recommendations */}
      <div className="space-y-6" aria-label="Loading recommendations">
        {[...Array(4)].map((_, i) => (
          <div 
            key={i}
            className="bg-white rounded-xl shadow-lg overflow-hidden animate-pulse"
            style={{ animationDelay: `${i * 150}ms` }}
          >
            <div className="p-6">
              <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-6">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
                    <div className="h-6 w-32 bg-blue-100 rounded-full"></div>
                  </div>
                  
                  <div className="h-7 bg-gray-200 w-3/4 rounded mb-4"></div>
                  <div className="h-4 bg-gray-100 rounded w-full mb-4"></div>
                  
                  <div className="space-y-4">
                    <div className="h-5 bg-gray-200 w-40 rounded"></div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {[...Array(4)].map((_, j) => (
                        <div key={j} className="flex items-center gap-2">
                          <div className="w-5 h-5 rounded-full bg-gray-200"></div>
                          <div className="h-4 bg-gray-100 rounded w-full"></div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                
                <div className="flex-shrink-0">
                  <div className="h-10 w-40 bg-blue-200 rounded-lg"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}